import { ErrorUpdater } from "../../../upgrade/error-updater";
import { ErrorResult } from "../../../upgrade/models/error-result";
import { Logger } from "../../utils/logger";

/**
 * Updater for Angular 15 errors.
 */
export class ErrorUpdaterAngular15 extends ErrorUpdater {
    /**
     * The function to parse the log file and update the errors.
     * @param log the input log.txt file data.
     * @param updateSource the update source.
     * @returns the count for unresolved errors.
     */
    public async resolveLogBuildErrors(log: string, updateSource: string[] = []): Promise<number> {
        const unresolvedErrorCount = await this.fixErrors(false, this.parseLogBuildErrors(log), updateSource, '15');
        Logger.log('INFO - unresolvedErrorCount:' + unresolvedErrorCount);
        this.checkNestedDependencies(log);
        return new Promise((resolve) => resolve(unresolvedErrorCount));
    }

    /**
     * The function to parse the log file and update the warnings.
     * @param log the input log.txt file data.
     * @param updateSource the update source.
     * @returns the count for unresolved errors.
     */
    public async resolveLogBuildWarnings(log: string, updateSource: string[] = []): Promise<number> {
        const unresolvedWarningCount = await this.fixErrors(false, this.parseLogBuildWarning(log), updateSource, '15');
        Logger.log('INFO - unresolvedWarningCount:' + unresolvedWarningCount);
        return new Promise((resolve) => resolve(unresolvedWarningCount));
    }

    /**
     * Gets the error results from the log file data.
     * @param log the log file data.
     * @returns the parsed error results.
     */
    protected parseLogBuildErrors(log: string): ErrorResult[] {
        return this.parseBuildErrorsCore(log);
    }

    /**
     * Gets the warning results from the log file data.
     * @param log the log file data.
     * @returns the parsed warning results.
     */
    protected parseLogBuildWarning(log: string): ErrorResult[] {
        return this.parseBuildWarningsCore(log);
    }

    /**
     * Checks if there are nested dependencies.
     * @param log the log file data.
     */
    protected checkNestedDependencies(log: string) {
        log.includes('NG3003') ?
            Logger.log('INFO - Nested dependencies found. Please manually fix them and verify by running: gulp build --prod\n') :
            Logger.log('INFO - No nested dependencies found.');
    }
}
